import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setGuestInfo } from "../../../redux/mealSlice";
import { useNavigate } from "react-router-dom";

const GuestInfoDialog = ({ open, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mealCount = useSelector((state) => state.meal.mealCount);
  const [guestInfo, setGuestInfoState] = useState([]);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    setGuestInfoState(Array(mealCount).fill(""));
    setErrors(Array(mealCount).fill(false)); // Initialize error states
  }, [mealCount]);

  const handleGuestNameChange = (index, value) => {
    const updatedGuestInfo = [...guestInfo];
    updatedGuestInfo[index] = value;
    setGuestInfoState(updatedGuestInfo);

    const updatedErrors = [...errors];
    updatedErrors[index] = !value.trim(); // Set error if the field is empty
    setErrors(updatedErrors);
  };

  const handleSubmit = () => {
    const validationErrors = guestInfo.map((guest) => !guest.trim());
    setErrors(validationErrors);

    if (validationErrors.some((error) => error)) {
      return; // Prevent submission if there are validation errors
    }

    dispatch(setGuestInfo(guestInfo));
    onClose();
    navigate("/mobile/scan");
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Enter Guest Names</DialogTitle>
      <DialogContent>
        {guestInfo.map((guest, index) => (
          <TextField
            key={index}
            label={`Guest ${index + 1}`}
            fullWidth
            value={guest}
            onChange={(e) => handleGuestNameChange(index, e.target.value)}
            error={errors[index]} // Highlight the field if there's an error
            helperText={errors[index] ? "This field is required" : ""}
            sx={{ mb: 2, mt: 1 }}
          />
        ))}
      </DialogContent>
      <DialogActions
        sx={{ mb: 3, display: "flex", justifyContent: "center", gap: 1 }}
      >
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{ background: "#004D72", color: "white" }}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GuestInfoDialog;
